import { Box, Grid } from "@mui/material";
import { SVGImgInitialTitle } from "@unit/svgs";
import NextLink from "next/link";
import React from "react";

import {
  authFooterCopyrightStyled,
  authFooterDividerStyled,
  authFooterItemStyled,
  authFooterLogoStyled,
  authFooterStyled,
} from "@/components/page-auth/auth-page-styles";
import {
  customerSupportPath,
  privacyPolicyPath,
  serviceOrganizationPath,
  termsPath,
} from "@/global-state/agency-app-path";

/**
 * 認証画面（A-1 / A-2 / A-3 / A-4）共通のフッター。
 *
 * リンクの並び順・運営会社リンク・ロゴ・Copyright は #1265 添付のデザインに合わせている（#1433）。
 */
const AuthFooterLinks: React.FC = () => (
  <Box>
    <Grid container alignItems="center" justifyContent="center" css={authFooterStyled}>
      <NextLink passHref href={privacyPolicyPath} target="_blank" rel="noopener noreferrer">
        プライバシーポリシー
      </NextLink>
      {/* 区切り線は後続リンクと同じ要素に入れる。別要素にすると狭い幅で行頭に取り残される */}
      <span css={authFooterItemStyled}>
        <span css={authFooterDividerStyled}>|</span>
        <NextLink passHref href={termsPath} target="_blank" rel="noopener noreferrer">
          利用規約
        </NextLink>
      </span>
      <span css={authFooterItemStyled}>
        <span css={authFooterDividerStyled}>|</span>
        <NextLink passHref href={serviceOrganizationPath} target="_blank" rel="noopener noreferrer">
          運営会社
        </NextLink>
      </span>
      <span css={authFooterItemStyled}>
        <span css={authFooterDividerStyled}>|</span>
        <NextLink passHref href={customerSupportPath} target="_blank" rel="noopener noreferrer">
          お問い合わせ
        </NextLink>
      </span>
    </Grid>
    <Grid container direction="column" alignItems="center" justifyContent="center" css={authFooterLogoStyled}>
      <SVGImgInitialTitle />
      <span css={authFooterCopyrightStyled}>Copyright © Unit, Inc. All Rights Reserved.</span>
    </Grid>
  </Box>
);

export default React.memo(AuthFooterLinks);
